import {
    IUpdateAcceptanceStatusSuccessAction,
    UpdateAcceptanceStatusErrorAction,
    IUpdateAcceptanceStatusAction
} from '../actions/update-acceptance-status';
import { IOrderTrackerState } from '../state';

export type LoadAcceptanceStatusAction
        = IUpdateAcceptanceStatusSuccessAction
        | UpdateAcceptanceStatusErrorAction
        | IUpdateAcceptanceStatusAction;

export const updateAcceptanceStatusTempReducer = (state: IOrderTrackerState,
    action: LoadAcceptanceStatusAction) => {

    return ({
        ...state,
        orderInfo: {
            ...state.orderInfo,
            data: {
                ...state.orderInfo.data,
                customerAcceptance: {
                    ...state.orderInfo.data.customerAcceptance,
                    acceptCallStatus: action.status
                }
            }
        }
    })
}
